/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Media_Noimages2Inputs */

const id_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada gambar ditemukan`)
};

const ms_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada imej ditemui`)
};

const da_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen billeder fundet`)
};

const de_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Bilder gefunden`)
};

const en_us2_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No images found`)
};

const es_es2_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron imágenes`)
};

const es_mx2_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron imágenes`)
};

const fil_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang larawan`)
};

const fr_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune image trouvée`)
};

const it_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna immagine trovata`)
};

const hu_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található kép`)
};

const nl_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen afbeeldingen gevonden`)
};

const no_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen bilder funnet`)
};

const pl_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono obrazów`)
};

const pt_br2_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma imagem encontrada`)
};

const pt_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma imagem encontrada`)
};

const ro_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit imagini`)
};

const fi_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvia ei löytynyt`)
};

const sv_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga bilder hittades`)
};

const vi_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy hình ảnh`)
};

const tr_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görsel bulunamadı`)
};

const cs_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné obrázky`)
};

const bg_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени изображения`)
};

const ru_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображения не найдены`)
};

const uk_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зображень не знайдено`)
};

const ar_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على صور`)
};

const hi_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई छवि नहीं मिली`)
};

const th_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรูปภาพ`)
};

const ja_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像が見つかりません`)
};

const zh_cn2_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到图像`)
};

const zh_hant1_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到圖像`)
};

const ko_offerdetail_media_noimages2 = /** @type {(inputs: Offerdetail_Media_Noimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미지를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No images found" |
*
* @param {Offerdetail_Media_Noimages2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_noimages2 = /** @type {((inputs?: Offerdetail_Media_Noimages2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Noimages2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_noimages2(inputs)
	if (locale === "ms") return ms_offerdetail_media_noimages2(inputs)
	if (locale === "da") return da_offerdetail_media_noimages2(inputs)
	if (locale === "de") return de_offerdetail_media_noimages2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_noimages2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_noimages2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_noimages2(inputs)
	if (locale === "fil") return fil_offerdetail_media_noimages2(inputs)
	if (locale === "fr") return fr_offerdetail_media_noimages2(inputs)
	if (locale === "it") return it_offerdetail_media_noimages2(inputs)
	if (locale === "hu") return hu_offerdetail_media_noimages2(inputs)
	if (locale === "nl") return nl_offerdetail_media_noimages2(inputs)
	if (locale === "no") return no_offerdetail_media_noimages2(inputs)
	if (locale === "pl") return pl_offerdetail_media_noimages2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_noimages2(inputs)
	if (locale === "pt") return pt_offerdetail_media_noimages2(inputs)
	if (locale === "ro") return ro_offerdetail_media_noimages2(inputs)
	if (locale === "fi") return fi_offerdetail_media_noimages2(inputs)
	if (locale === "sv") return sv_offerdetail_media_noimages2(inputs)
	if (locale === "vi") return vi_offerdetail_media_noimages2(inputs)
	if (locale === "tr") return tr_offerdetail_media_noimages2(inputs)
	if (locale === "cs") return cs_offerdetail_media_noimages2(inputs)
	if (locale === "bg") return bg_offerdetail_media_noimages2(inputs)
	if (locale === "ru") return ru_offerdetail_media_noimages2(inputs)
	if (locale === "uk") return uk_offerdetail_media_noimages2(inputs)
	if (locale === "ar") return ar_offerdetail_media_noimages2(inputs)
	if (locale === "hi") return hi_offerdetail_media_noimages2(inputs)
	if (locale === "th") return th_offerdetail_media_noimages2(inputs)
	if (locale === "ja") return ja_offerdetail_media_noimages2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_noimages2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_noimages2(inputs)
	return ko_offerdetail_media_noimages2(inputs)
});
export { offerdetail_media_noimages2 as "offerDetail.media.noImages" }